export let question1 = [
  {
    question: "Qui sont les membres permanents de l'ONU ?",
    options: [
      "Chine – Russie – France – USA - Royaume Uni – Japon",
      "Chine – Russie – France – USA - Royaume Uni – Brésil",
      "Chine – France – USA - Royaume Uni – Allemagne",
      "Chine – Russie – France – USA - Royaume Uni"
    ],
    answerIndex: 3
  },
  {
    question: "Combien d'États ont signé la Charte de l'Atlantique ?",
    options: ["24", "22", "28", "26"],
    answerIndex: 3
  },
  {
    question: "Trouver l'intrus (lequel ne fait pas partie des principes de l'ONU)",
    options: [
      "Maintenir la paix et la sécurité dans le monde",
      "L'égalité souveraine de tous les États membres (pas d'ingérence dans les affaires intérieures des États)",
      "L'application par tous les États membres des résolutions et sanctions adoptées par l'ONU",
      "Le respect de l'intégrité territoriale des États membres",
      "Le règlement des différends internationaux par la voie pacifique en privilégiant le dialogue"
    ],
    answerIndex: 0
  },
  {
    question: "Trouver l'intrus (lequel ne fait pas partie des objectifs de l'ONU)",
    options: [
      "Être un centre où s'harmonisent les efforts des nations dans des objectifs communs",
      "Promouvoir et défendre les droits de l'homme",
      "Promouvoir le développement durable",
      "L'union des forces pour le maintien de la paix et de sécurité internationale",
      "Réaliser la coopération internationale sur tous les sujets"
    ],
    answerIndex: 3
  },
  {
    question: "Où a été signée la Charte de l'ONU ?",
    options: ["Dumbarton Oaks", "Yalta", "Moscou", "Teheran", "San Francisco"],
    answerIndex: 4
  },
  {
    question: "Quel est l'organe administratif de l'ONU ?",
    options: [
      "Le Conseil de Sécurité",
      "L'Assemblée Générale",
      "Le Conseil Économique et Social",
      "Le Secrétariat Général"
    ],
    answerIndex: 3
  },
  {
    question: "Quelle est la durée du mandat des juges de la Cour Internationale de Justice ?",
    options: ["9 ans", "15 ans"],
    answerIndex: 0
  },
  {
    question: "Où se trouve le siège de l'UNESCO ?",
    options: ["Washington", "New York", "Genève", "Paris", "Montréal"],
    answerIndex: 3
  }
];
export let question2 = [
  {
    question: "Quel est le rôle de la thèse ?",
    options: [
      "Affirmer une proposition",
      "Infirmer une proposition",
      "Les deux"
    ],
    answerIndex: 2
  },
  {
    question: "À quoi consiste l’antithèse ?",
    options: [
      "Apporter des contre arguments",
      "Développer un argumentaire"
    ],
    answerIndex: 0
  },
  {
    question: "Quel est le rôle de la synthèse ?",
    options: [
      "Résumer la thèse et l’antithèse",
      "Surmonter une contradiction apparente entre la thèse et l’antithèse",
      "Faire une conclusion"
    ],
    answerIndex: 1
  },
  {
    question: "Qui a parlé de la fonction libératrice de la philosophie ?",
    options: [
      "Alain",
      "Auguste Comte",
      "Bertrand Russel",
      "Pierre Fougeyrollas"
    ],
    answerIndex: 2
  }
];
export let question3  = [
  {
    question: "L’allèle responsable de la maladie M1 de la Famille A est :",
    options: [
      "Dominant",
      "Récessif"
    ],
    answerIndex: 1
  },
  {
    question: "L’allèle responsable de la maladie M2 de la Famille B est :",
    options: [
      "Dominant",
      "Récessif"
    ],
    answerIndex: 0
  },
  {
    question: "Pourquoi l’allèle M1 est autosomal ?",
    options: [
      "La fille 12 (M1) permet d’affirmer que la maladie M1 n’est pas portée par le gonosome Y",
      "Le père 10 (S1) permet d’affirmer que la maladie M1 n’est pas portée par le gonosome X",
      "Les deux"
    ],
    answerIndex: 2
  },
  {
    question: "L’allèle M2 responsable de la répartition de la maladie dans la famille B est porté par :",
    options: [
      "Le gonosome X",
      "Le gonosome Y"
    ],
    answerIndex: 0
  },
  {
    question: "La démarche OPHERIC est :",
    options: [
      "Une démarche hypothétique",
      "Une démarche hypothético-déductive",
      "Une démarche déductive"
    ],
    answerIndex: 1
  }
];
export let question4  = [
  {
    question: "Quelle datation consiste à donner un âge approximatif ?",
    options: [
      "Datation Relative ",
      "Datation Absolue",
      "En combien"
    ],
    answerIndex: 0
  },
  {
    question: "À quelle ère appartiennent le Paléolithique et le Néolithique ?",
    options: [
      "Le Précambrien",
      "L’Ère Tertiaire",
      "L’Ère Primaire",
      "L’Ère Quaternaire ",
      "L’Ère Secondaire"
    ],
    answerIndex: 3
  },
  {
    question: "Quelle est l’Ère des mammifères ?",
    options: [
      "Le Précambrien",
      "L’Ère Tertiaire",
      "L’Ère Primaire",
      "L’Ère Quaternaire ",
      "L’Ère Secondaire"
    ],
    answerIndex: 3
  },
  {
    question: "Où a été découvert l’Australopithèque ?",
    options: [
      "Les Pyrénées",
      "La Tanzanie ",
      "Les Alpes"
    ],
    answerIndex: 1
  },
  {
    question: "À quand date l’apparition de la vie végétale et la vie animale sur terre ferme ?",
    options: [
      "Le Précambrien",
      "À la fin de L’Ère Tertiaire",
      "À la fin de L’Ère Primaire ",
      "À la fin de L’Ère Quaternaire",
      "À la fin de L’Ère Secondaire"
    ],
    answerIndex: 2
  },
  {
    question: "Quel est l’âge actuel de la terre ?",
    options: [
      "46 milliards d’années",
      "4,6 millions d’années",
      "460 millions d’années",
      "4,6 milliards d’années "
    ],
    answerIndex: 3
  }
];
export let question5  = [
  {
    question: "Quand est-ce que s’est tenue la conférence de Berlin ?",
    options: ["1985", "1885 ", "1785", "1858"],
    answerIndex: 1
  },
  {
    question: "Quels étaient les 2 principaux rivaux pour la possession du Congo ?",
    options: ["Français et Portugais", "Portugais et Belges", "Français et Belges "],
    answerIndex: 2
  },
  {
    question: "Quelle a été la dernière puissance à s’intéresser à la colonisation ?",
    options: ["Allemagne ", "France", "Belgique", "Portugal"],
    answerIndex: 0
  },
  {
    question: "Qui a convoqué la conférence de Berlin ?",
    options: ["Le Général Charles de Gaulle", "Le Chancelier Bismarck ", "Le Roi Léopold II"],
    answerIndex: 1
  },
  {
    question: "Où s’est tenue la conférence de Berlin ?",
    options: ["En France", "En Allemagne ", "En Belgique", "Au Portugal"],
    answerIndex: 1
  }
]